<template>
    <div class="ads-info-page">
        <div class="ads-info-page-header">
            <el-form inline :model="formData" size="mini" ref="formInline">
                <el-form-item prop="account">
                    <CustomInput  label='账户' @append-click="handleGenAppendClick('account', '输入或粘贴名称或ID，每行一个')">
                        <ESelect
                            v-model="formData.account"
                            filterable
                            clearable
                            placeholder="请输入账户名称关键字/精准ID搜索选择"
                            multiple
                            collapse-tags
                            remote
                            reserve-keyword
                            :loading="searchLoading"
                            ref="account"
                            @visible-change="(val)=>handleVisibleChange(val, 'account')"
                            :remote-method="(search) => appEntrySearchList(search, 'account', {trigger_record_id: id})"
                            style="width: 250px;"
                        >
                            <p class="option-select">
                                <el-button type="text" @click="()=>handleSelectAll(account_DataList, 'account', 'all')">全选</el-button>
                                <el-button type="text" @click="()=>handleSelectAll(account_DataList, 'account', 'cancel')">取消全选</el-button>
                            </p>
                            <el-option
                                v-for="item in account_DataList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                            />
                        </ESelect>
                        <template #append>
                            <i class="el-icon-document-copy"/>
                        </template>
                    </CustomInput>
                </el-form-item>

                <el-form-item prop="plan">
                    <CustomInput label='计划' @append-click="handleGenAppendClick('plan', '输入或粘贴名称或ID，每行一个')">
                        <ESelect
                            v-model="formData.plan"
                            filterable
                            clearable
                            placeholder="请输入计划名称关键字/精准ID搜索选择"
                            multiple
                            collapse-tags
                            remote
                            reserve-keyword
                            :loading="searchLoading"
                            ref="plan"
                            @visible-change="(val)=>handleVisibleChange(val, 'plan')"
                            :remote-method="(search) => appEntrySearchList(search, 'plan', {trigger_record_id: id})"
                            style="width: 250px;"
                        >
                            <p class="option-select">
                                <el-button type="text" @click="()=>handleSelectAll(plan_DataList, 'plan', 'all')">全选</el-button>
                                <el-button type="text" @click="()=>handleSelectAll(plan_DataList, 'plan', 'cancel')">取消全选</el-button>
                            </p>
                            <el-option
                                v-for="item in plan_DataList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                            />
                        </ESelect>
                        <template #append>
                            <i class="el-icon-document-copy"/>
                        </template>
                    </CustomInput>
                </el-form-item>
                <el-form-item prop="adgroup">
                    <CustomInput label='广告组' @append-click="handleGenAppendClick('adgroup', '输入或粘贴名称或ID，每行一个')">
                        <ESelect
                            v-model="formData.adgroup"
                            filterable
                            clearable
                            placeholder="请输入广告组名称关键字/精准ID搜索选择"
                            multiple
                            collapse-tags
                            remote
                            reserve-keyword
                            :loading="searchLoading"
                            ref="adgroup"
                            @visible-change="(val)=>handleVisibleChange(val, 'adgroup')"
                            :remote-method="(search) => appEntrySearchList(search, 'adgroup', {trigger_record_id: id})"
                            style="width: 250px;"
                        >
                            <p class="option-select">
                                <el-button type="text" @click="()=>handleSelectAll(adgroup_DataList, 'adgroup', 'all')">全选</el-button>
                                <el-button type="text" @click="()=>handleSelectAll(adgroup_DataList, 'adgroup', 'cancel')">取消全选</el-button>
                            </p>
                            <el-option
                                v-for="item in adgroup_DataList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                            />
                        </ESelect>
                        <template #append>
                            <i class="el-icon-document-copy"/>
                        </template>
                    </CustomInput>
                </el-form-item>
                <el-form-item prop="ad">
                    <CustomInput label='创意' @append-click="handleGenAppendClick('ad', '输入或粘贴名称或ID，每行一个')">
                        <ESelect
                            v-model="formData.ad"
                            filterable
                            clearable
                            placeholder="请输入创意名称关键字/精准ID搜索选择"
                            multiple
                            collapse-tags
                            remote
                            reserve-keyword
                            :loading="searchLoading"
                            ref="ad"
                            @visible-change="(val)=>handleVisibleChange(val, 'ad')"
                            :remote-method="(search) => appEntrySearchList(search, 'ad', {trigger_record_id: id})"
                            style="width: 250px;"
                        >
                            <p class="option-select">
                                <el-button type="text" @click="()=>handleSelectAll(ad_DataList, 'ad', 'all')">全选</el-button>
                                <el-button type="text" @click="()=>handleSelectAll(ad_DataList, 'ad', 'cancel')">取消全选</el-button>
                            </p>
                            <el-option
                                v-for="item in ad_DataList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                            />
                        </ESelect>
                        <template #append>
                            <i class="el-icon-document-copy"/>
                        </template>
                    </CustomInput>
                </el-form-item>
                 <el-form-item prop="app">
                    <CustomInput label='产品' @append-click="handleGenAppendClick('app', '输入或粘贴名称或ID，每行一个')">
                        <ESelect
                            v-model="formData.app"
                            filterable
                            clearable
                            placeholder="请输入产品名称关键字/精准ID搜索选择"
                            multiple
                            collapse-tags
                            remote
                            reserve-keyword
                            :loading="searchLoading"
                            ref="app"
                            @visible-change="(val)=>handleVisibleChange(val, 'app')"
                            :remote-method="(search) => appEntrySearchList(search, 'app', {trigger_record_id: id})"
                            style="width: 250px;"
                        >
                            <p class="option-select">
                                <el-button type="text" @click="()=>handleSelectAll(app_DataList, 'app', 'all')">全选</el-button>
                                <el-button type="text" @click="()=>handleSelectAll(app_DataList, 'app', 'cancel')">取消全选</el-button>
                            </p>
                            <el-option
                                v-for="item in app_DataList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                            />
                        </ESelect>
                        <template #append>
                            <i class="el-icon-document-copy"/>
                        </template>
                    </CustomInput>
                </el-form-item>
                <el-form-item prop="director_uid">
                    <CustomInput label='状态'>
                        <SelectAll :options="status" v-model="formData.status"/>
                    </CustomInput>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" :loading="loading" @click="handleQueryClick" v-matomo="{behaviorCategory: '广告批量调控', event: '点击',  name: '详情(查询)' }">查询</el-button>
                     <el-button
                v-if="getCurAuth('export')"
                style="margin-bottom: 18px;"
                icon="el-icon-download"
                size="mini" :loading="exportLoading" @click="exportData" v-matomo="{behaviorCategory: '广告批量调控', event: '点击',  name: '详情(导出)' }">导出</el-button>
                </el-form-item>
            </el-form>
           
        </div>
        <div class="ads-info-page-content">
            <el-table
                :data="tableData"
                style="width: 100%"
                :header-cell-style="{ background: 'rgb(245, 247, 250)', color: '#333' }"
                size="mini"
                header-cell-class-name="header-cell"
                ref="refs_table"
                :max-height="tableHeight"
                v-loading="loading"
                :row-style="rowStyle"
            >
                <!-- 默认 -->
                <el-table-column
                    :prop="column.field"
                    :label="column.name"
                    v-for="(column, index) in columns"
                    :key="index"
                    align="center"
                    min-width="200"
                >
                     <template slot-scope="scope">
                        <HoverEllipsisTips :text="scope.row[column.field] || '-'" />
                    </template>
                     <template v-if="column.child && column.child.length > 0">
                        <el-table-column
                            :prop="child.field"
                            :label="child.name"
                            v-for="(child, childIndex) in column.child"
                            :key="childIndex"
                             min-width="200"
                        >
                            <template slot-scope="scope">
                                <!-- <HoverEllipsisTips :text="scope.row[child.field] || '-'" /> -->
                                <p class="ellipsis" :title="html2Text(scope.row[child.field] || '-')" v-html="scope.row[child.field] || '-'"/>
                            </template>
                        </el-table-column>
                    </template>
                </el-table-column>
            </el-table>
            <div class="tar pt20 pr20">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                               :current-page="currentPage" :page-sizes="[30, 50, 100]" :page-size="pageSize"
                               layout="total, sizes, prev, pager, next, jumper" :total="total">
                </el-pagination>
            </div>
        </div>
    </div>
</template>
<script>
import CustomInput from "@/components/CustomInput/index.vue";
import SelectAll from "@/components/SelectAll/index.vue";
import API from "@/api/intelligent/intelligentManaged/index.js";
import {batchSelectModal} from "@/components/modal";
import HoverEllipsisTips from "@/components/TextEllips/index.vue";
import { html2Text } from '@/utils'
export default {
    name: 'ads_info_modal',
    components: {HoverEllipsisTips, SelectAll, CustomInput},
    props:['id', 'pageFuncNames', 'params'],
    data() {
        return {
            html2Text,
            account_DataList: [],
            plan_DataList: [],
            adgroup_DataList: [],
            ad_DataList: [],
            // creative_DataList: [],
            app_DataList: [],
            status: [
                {
                    value: 1,
                    id: 1,
                    label: '修改成功'
                },
                {
                    value: 2,
                    id: 2,
                    label: '修改失败'
                }
            ],
            formData:{
                account: [],  //编导
                plan: [],  //项目名称
                adgroup: [],  //广告组
                creative: [],  //创意
                ad: [],  //广告
                status: [],  //工单
            },
            currentPage: 1,
            pageSize: 30,
            pageNum: 1,
            columns: [],
            tableData: [],
            total: 0,
            loading: false,
            exportLoading: false,
            searchLoading: false,
        }
    },
    computed: {
        tableHeight(){
            return document.body.clientHeight - 400;
        }
    },
    mounted() {
        this.handleQueryClick()
    },
    methods: {
        rowStyle({row}) {
            if (row.color ) {
                return {
                    background: row.color,
                }
            }
        },
        // 操作权限
        getCurAuth(name) {
            return this.pageFuncNames.includes(name);
        },
        handleQueryClick() {
            this.currentPage = 1;
            this.fetchGetList({trigger_record_id: this.id, ...this.formData, pn:1,rn:this.pageSize})
        },
        fetchGetList(params) {
            if(!params.export) {
                this.loading = true
            }
            API.postInfoListApi(params).then((res)=>{
                if (!params.export) {
                    this.columns = res.data.field
                    setTimeout(()=>{
                        this.tableData = res?.data?.list ? res.data.list : []
                        this.total = res.data.totalCnt
                        this.exportLoading = false
                        this.loading = false
                    },10)

                }else{
                    // 导出的情况
                    this.exportLoading = false
                    this.loading = false
                    this.$message.success(res.info)
                }
            }, err=>{
                this.loading = false
                this.$message.error(err.info)
            })
        },
        // 每页条数
        handleSizeChange(val) {
            this.pageSize = val
            this.currentPage = 1;
            let res_params = {...this.formData, trigger_record_id:this.id, pn:this.currentPage,rn:this.pageSize}
            this.fetchGetList(res_params)
        },
        // 当前页数
        handleCurrentChange(val) {
            this.currentPage = val
            let res_params = {...this.formData,trigger_record_id:this.id, pn:this.currentPage,rn:this.pageSize}
            this.fetchGetList(res_params)
        },
        // 导出
        async exportData() {
            try {
                this.exportLoading = true
                let res_params = {...this.formData,trigger_record_id:this.id, pn:this.currentPage,rn:this.pageSize, export: '1' }
                await this.fetchGetList(res_params)
                // await this.getList()
            } catch (error) {
                this.exportLoading = false
                throw error
            }
        },
        // 下拉检索
        async appEntrySearchList(search, type, p ={}, cb) {
            try {
                const params = {
                    search_type: type,
                    search,
                    ...p
                };
                this.searchLoading = true
                const { data } = await API.postInfoSelectApi(params);
                const list = data.list;
                const errList = data.err_list;
                if (params.batch_search) {
                    cb(errList, ()=> {
                        const ids = list.map(v=>v.id)
                        this[`${type}_DataList`] = [
                            ...this[`${type}_DataList`].filter(v=>this.formData[type].includes(v.value)&&!ids.includes(v.value)),
                            ...list.map(v=> {
                                return {
                                    ...v,
                                    value: v.id,
                                    label: v.name
                                }
                            })
                        ]
                        this.formData[type] = [...new Set([ ...this.formData[type], ...ids ])];
                    })
                }else {
                    this[`${type}_DataList`]= list.map(v=> {
                        return {
                            ...v,
                            value: v.id,
                            label: v.name
                        }
                    })
                }
            } catch (error) {
                this.$message.warning(error.info)
            } finally {
                this.searchLoading = false
            }
        },
        handleGenAppendClick(type, placeholder) {
            const onSubmit = (data, callback)=> {
                if (data.length === 0) {
                    callback();
                    this.$message.error('请输入或粘贴名称或ID');
                    return
                }
                this.appEntrySearchList(
                    '',
                    type,
                    {
                        batch_search: data,
                        trigger_record_id: this.id
                    },
                    (errs, cb)=> {
                        callback();
                        if (errs.length) {
                            delErrList({
                                tip: '未找到以下数据信息，请核实，是否需要剔除未找到的?',
                                list: errs,
                                onOk: ()=> {
                                    cb();
                                    vm.close();
                                }
                            })
                        }else {
                            cb();
                            vm.close();
                        }
                    }
                )
            }
            const { vm, delErrList } = batchSelectModal({
                title: '批量添加',
                props: {
                    tip: placeholder ? placeholder : '输入或粘贴名称或ID，每行一个',
                    hasLoading: true
                },
                cbs: {
                    onSubmit
                }
            })
        },
        handleVisibleChange(visible, type) {
            if (visible) {
                const options = this.$refs[type].selected|| [];
                const listData = options.map(v=> {
                    return v.$options.propsData
                });
                this.$set(this, `${type}_DataList`, listData)
            }
        },
        handleSelectAll(list, type, selectType) {
            if(selectType === 'all') {
                const data = [...(this.formData[type] || [])];
                data.push(...list.map(v=>v.value));
                // 去重 赋值
                this.formData[type] = [ ...new Set(data)]
            }else{
                let optionList_ids = this[`${type}_DataList`].map(item=>item.value)
                let channel_ids = this.formData[type].filter(item=> !optionList_ids.includes(item))
                this.formData[type] = [...channel_ids]
            }
        },
    }
}
</script>
<style lang="scss" scoped>
.ads-info-page-header{
    display: flex;
    justify-content: space-between;
    align-items: center;
}
</style>
